import { inject } from 'vue'
import type { EditorContext } from '../types/editor.types'

export const EDITOR_INJECTION_KEY = Symbol('ghl-editor-context') as unknown as string

export const useEditor = (): EditorContext => {
  const ctx = inject<EditorContext | null>(EDITOR_INJECTION_KEY, null)
  if (!ctx) {
    throw new Error('useEditor() must be used under <EditorRoot>')
  }
  return ctx
}
